class MercaveloPremium {
  constructor() {
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.initHero();
    this.initReveal();
  }

  initHero() {
    const hero = document.querySelector('.mv-hero');
    if (!hero) return;
    requestAnimationFrame(() => hero.classList.add('is-loaded'));
  }

  initReveal() {
    const items = document.querySelectorAll('.mv-reveal');
    if (!items.length) return;

    if (this.reducedMotion || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    items.forEach((item) => observer.observe(item));
  }

}

const initMercaveloPremium = () => new MercaveloPremium();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMercaveloPremium, { once: true });
} else {
  initMercaveloPremium();
}

document.addEventListener('shopify:section:load', initMercaveloPremium);
